
<a :href="url" class="d-flex align-items-center justify-content-between">
    <app-normal-text :text="title"></app-normal-text>
    <app-normal-text v-if="isContentBold" class="mr-5" :text="text"></app-normal-text>
    <app-normal-text2 v-else class="mr-5" :text="text"></app-normal-text2>
</a>
